import React, { useRef, useState, useEffect } from 'react';
import MovieThumb from '../MovieThumb/index.js';
import { NavLink } from 'react-router-dom';
import './movieSlider.scss';

const MovieSlider = ({ group, versions = [], onImageLoad, scrollKey }) => {
    const sliderRef = useRef(null);
    const [showLeftButton, setShowLeftButton] = useState(false);
    const [showRightButton, setShowRightButton] = useState(false);

    const handleScrollLeft = () => {
        sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    };

    const handleScrollRight = () => {
        sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    };

    const updateScrollButtons = () => {
        if (sliderRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
            setShowLeftButton(scrollLeft > 0);
            setShowRightButton(scrollWidth - clientWidth - scrollLeft > 0);
        }
    };

    // Restore scroll position after content renders
    useEffect(() => {
        if (scrollKey && sliderRef.current && versions.length > 0) {
            const saved = sessionStorage.getItem(`movieSlider_${scrollKey}`);
            if (saved) {
                sliderRef.current.scrollLeft = parseInt(saved, 10);
            }
        }
    }, [scrollKey, versions.length]);

    // Save scroll position on scroll (debounced)
    useEffect(() => {
        if (!scrollKey) return;
        const slider = sliderRef.current;
        let timeout;
        const handleScroll = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                sessionStorage.setItem(`movieSlider_${scrollKey}`, slider.scrollLeft);
            }, 100);
        };
        slider?.addEventListener('scroll', handleScroll);
        return () => {
            clearTimeout(timeout);
            slider?.removeEventListener('scroll', handleScroll);
        };
    }, [scrollKey]);

    useEffect(() => {
        const slider = sliderRef.current;
        updateScrollButtons();
        window.addEventListener('resize', updateScrollButtons);
        slider.addEventListener('scroll', updateScrollButtons);
        return () => {
            window.removeEventListener('resize', updateScrollButtons);
            slider.removeEventListener('scroll', updateScrollButtons);
        };
    }, []);

    return (
        <div className="ps-0 pt-4 position-relative movie-slider-component">
            <h1 className="text-uppercase">{group}</h1>

            {showLeftButton && (
                <button className="scroll-button scroll-button-left h-100" onClick={handleScrollLeft}>
                    <span className="fas fa-chevron-left" />
                </button>
            )}

            <div ref={sliderRef} className="movie-slider d-flex justify-content-start mt-2 overflow-x-auto">
                {versions.map(({ _id: orderId, movie, version, status, hasTrailer }, index) => (
                    <NavLink
                        key={orderId}
                        to={`/movie-version/${version?._id}/order/${orderId}`}
                        state={{ feed: versions, feedIndex: index, feedKey: scrollKey }}
                        className="text-decoration-none text-white"
                    >
                        <MovieThumb movie={movie} version={version} orderStatus={status} onImageLoad={onImageLoad} hasTrailer={hasTrailer} />
                    </NavLink>
                ))}
            </div>

            {showRightButton && (
                <button className="scroll-button scroll-button-right h-100" onClick={handleScrollRight}>
                    <span className="fas fa-chevron-right" />
                </button>
            )}
        </div>
    );
};

export default MovieSlider;
